import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'
import i18n from '@vue-storefront/i18n'
import { mapGetters } from 'vuex'

export const Breadcrumbs = {
  computed: {
    ...mapGetters({
      getBreadcrumbsRoutes: 'breadcrumbs/getBreadcrumbsRoutes',
      getBreadcrumbsCurrent: 'breadcrumbs/getBreadcrumbsCurrent'
    }),
    paths () {
      const routes = this.routes ? this.routes : this.getBreadcrumbsRoutes

      if (this.withHomepage) {
        return [
          { name: i18n.t('Homepage'), route_link: localizedRoute('/') },
          ...routes
        ]
      }

      return routes
    },
    current () {
      const activeLocation = this.activeRoute || this.getBreadcrumbsCurrent
      const current = i18n.t(activeLocation);
      return current
    }
  },
  props: {
    routes: {
      type: Array,
      required: false,
      default: null
    },
    withHomepage: {
      type: Boolean,
      default: false
    },
    activeRoute: {
      type: String,
      default: ''
    }
  }
}
